var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuarantine = function SvgQuarantine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.7 20.5h8.6v-3.175q0-1.8-1.25-3.037Q13.8 13.05 12 13.05t-3.05 1.237-1.25 3.038zM4 22v-1.5h2.2v-3.175q0-1.774 1-3.225A5.67 5.67 0 0 1 9.85 12 5.83 5.83 0 0 1 7.2 9.875a5.55 5.55 0 0 1-1-3.225V3.5H4V2h16v1.5h-2.2v3.15a5.55 5.55 0 0 1-1 3.225A5.83 5.83 0 0 1 14.15 12a5.68 5.68 0 0 1 2.65 2.1q1 1.45 1 3.225V20.5H20V22z"
  })));
};
export default SvgQuarantine;